import apiClient from './authService';

const maintenanceService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await apiClient.get(`/api/maintenance?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/api/maintenance/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/api/maintenance', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/api/maintenance/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/api/maintenance/${id}`);
    return response.data;
  },

  addComment: async (id, text) => {
    const response = await apiClient.post(`/api/maintenance/${id}/comments`, { text });
    return response.data;
  },

  addCost: async (id, costData) => {
    const response = await apiClient.post(`/api/maintenance/${id}/costs`, costData);
    return response.data;
  },

  submitApproval: async (id, action, reason) => {
    const response = await apiClient.post(`/api/maintenance/${id}/approval-action`, { action, reason });
    return response.data;
  },

  getConversation: async (id) => {
    const response = await apiClient.get(`/api/maintenance/${id}/conversation`);
    return response.data;
  },

  // ============================================
  // CONVERSATIONAL MAINTENANCE CHAT METHODS
  // ============================================

  /**
   * Send a message in a conversational maintenance request flow
   * @param {string} sessionId - Unique session identifier
   * @param {string} message - User's message
   * @returns {Promise} - Agent response with conversation state
   */
  sendChatMessage: async (sessionId, message, imageUrls = null) => {
    const body = { message, sessionId };
    if (imageUrls && imageUrls.length > 0) {
      body.image_urls = imageUrls;
    }
    const response = await apiClient.post('/api/maintenance/chat', body);
    return response.data;
  },

  /**
   * Upload maintenance issue photos to GCS
   * @param {File[]} files - Array of image files (max 2)
   * @returns {Promise<{image_urls: string[]}>}
   */
  uploadPhotos: async (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('photos', file));
    const response = await apiClient.post('/api/maintenance/chat/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * Get the status of a maintenance chat conversation
   * @param {string} sessionId - Session identifier
   * @returns {Promise} - Current conversation state
   */
  getChatStatus: async (sessionId) => {
    const response = await apiClient.get(`/api/maintenance/chat/status/${sessionId}`);
    return response.data;
  },

  /**
   * Reset a maintenance chat conversation
   * @param {string} sessionId - Session identifier
   * @returns {Promise} - Success confirmation
   */
  resetChat: async (sessionId) => {
    const response = await apiClient.post('/api/maintenance/chat/reset', {
      sessionId
    });
    return response.data;
  }
};

export default maintenanceService;
